import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, DocumentosSetoriaisReducer, DocumentosSetoriaisState } from "./documentos-setoriais-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IDocumentoSetorialPagedResponse } from "models/response/documento-setorial-paged-response";

const DocumentosSetoriaisContext = createContext<DocumentosSetoriaisState | undefined>(undefined);
const DocumentosSetoriaisContextDispatchContext = createContext({} as any);

const DocumentosSetoriaisProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(DocumentosSetoriaisReducer, {
        documentos: new PaginationResponse<IDocumentoSetorialPagedResponse>([], 0, 1, 10, 0),
        documentoSetorialPagedRequest: { page: 0, pageSize: 10 },
        tipos: [],
        areas: [],
        ultimaAtualizacao: null,
        totais: { total: 0, emExecucao: 0, finalizados: 0 },
        loading: false,
        error: null
    } as DocumentosSetoriaisState);

    return (
        <DocumentosSetoriaisContext.Provider value={state}>
            <DocumentosSetoriaisContextDispatchContext.Provider value={dispatch}>
                {children}
            </DocumentosSetoriaisContextDispatchContext.Provider>
        </DocumentosSetoriaisContext.Provider>
    );
}

const useDocumentosSetoriaisState = () => {
    const context = useContext(DocumentosSetoriaisContext);
    if (context === undefined) {
        throw new Error('useDocumentosSetoriaisState must be used within a DocumentosSetoriaisProvider');
    }
    return context;
}

const useDocumentosSetoriaisDispatch = () => {
    const context = useContext(DocumentosSetoriaisContextDispatchContext);
    if (context === undefined) {
        throw new Error('useDocumentosSetoriaisDispatch must be used within a DocumentosSetoriaisProvider');
    }
    return context;
}

export { DocumentosSetoriaisProvider, useDocumentosSetoriaisState, useDocumentosSetoriaisDispatch, ACTION_TYPES };
